import React, { Fragment } from "react";
import Label from "./Label";

const EmailInput = passedProps => {
  const {
    label,
    name,
    value,
    handleChange,
    placeholder,
    required,
    ...props
  } = passedProps;
  return (
    <Fragment>
      <Label htmlFor={name} required={required}>
        {label}
      </Label>
      <input
        className="form-control"
        id={name}
        name={name}
        type="email"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        {...props}
      />
    </Fragment>
  );
};

export default EmailInput;
